function handle_submit_buttons() {
    const buttons = document.querySelectorAll<HTMLAnchorElement>('a.submit_button');
    for (const button of buttons) {
        let form = get_parent_form(button);
        if (form !== null) {
            button.href = form.action;
            button.addEventListener('click', (ev) => {
                form.submit();
                ev.preventDefault();
            });
        }
    }
}

function get_parent_form(element: HTMLElement): HTMLFormElement | null {
    let chain: HTMLElement = element;
    while (chain.parentElement !== null) {
        const parent = chain.parentElement;

        if (parent.tagName === 'FORM') {
            return parent as HTMLFormElement;
        }

        chain = parent;
    }

    return null;
}

function main() {
    handle_submit_buttons();
}

document.addEventListener('DOMContentLoaded', main);
